import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./styles.module.css";
import InputCurrency from "../../../components/Campo/InputCurrency";
import { useState } from "react";
import { DocumentoNaoCompensado } from "../../../model/PrestacaoDeContas/ConciliacaoBancaria";
import { toIsoString } from "../../../controllers/Converters";
import Modal from "react-responsive-modal";
import ModalConciliacaoBancaria from "../../../components/ModalForms/ModalConciliacaoBancaria";

const ConciliacaoBancaria = () => {
  const [showAddConciliacao, setAddConciliacao] = useState(false);
  const [showEditConciliaco, setEditConciliacao] = useState(-1);
  const [saldoBancario, setSaldoBancario] = useState(0);
  const [debitos, setDebitos] = useState(0);
  const [creditos, setCreditos] = useState(0);
  const [outros, setOutros] = useState(0);
  const [documentos, setDocumentos] = useState<DocumentoNaoCompensado[]>([
    {
      nome: "Nota fiscal 3344",
      numero: "23-788",
      data: new Date(Date.now()),
      favorecido: "José de souza oliveira",
      valor: 550,
    },
    {
      nome: "Nota fiscal 3344",
      numero: "23-788",
      data: new Date(Date.now()),
      favorecido: "José de souza oliveira",
      valor: 550,
    },
    {
      nome: "Nota fiscal 3344",
      numero: "23-788",
      data: new Date(Date.now()),
      favorecido: "José de souza oliveira",
      valor: 550,
    },
  ]);
  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          6. Conciliação <strong>Bancária</strong>
        </h2>
        <div className={styles.table}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>HISTÓRICO</TableCell>
                  <TableCell align="center">VALOR</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    SALDO BANCÁRIO EM (conforme extrato anexo)
                  </TableCell>
                  <TableCell align="center">
                    <InputCurrency
                      value={saldoBancario}
                      setter={setSaldoBancario}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    (-) OB's, cheques e ou lançamentos a DÉBITO
                  </TableCell>
                  <TableCell align="center">
                    <InputCurrency value={debitos} setter={setDebitos} debito />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    (+) DEPÓSITOS e ou lançamentos de CRÉDITOS
                  </TableCell>
                  <TableCell align="center">
                    <InputCurrency
                      value={creditos}
                      setter={setCreditos}
                      credito
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>(+/=) Outros Tarifa Bancária</TableCell>
                  <TableCell align="center">
                    <InputCurrency
                      value={outros}
                      setter={setOutros}
                      credito
                      debito
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell>SALDO FINAL</TableCell>
                  <TableCell align="center">
                    R${" "}
                    {(saldoBancario + debitos + creditos + outros).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
        <hr />
        <div className={styles.table}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={5}>
                    DOCUMENTOS EMITIDOS E NÃO COMPENSADOS NO PERIODO
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>DOCUMENTO</TableCell>
                  <TableCell>N°</TableCell>
                  <TableCell>DATA</TableCell>
                  <TableCell>FAVORECIDO</TableCell>
                  <TableCell>VALOR</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {documentos.map((documento, index) => (
                  <>
                    <TableRow
                      hover
                      role="checkbox"
                      sx={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setEditConciliacao(index);
                      }}
                    >
                      <TableCell>{documento.nome}</TableCell>
                      <TableCell>{documento.numero}</TableCell>
                      <TableCell>{toIsoString(documento.data)}</TableCell>
                      <TableCell>{documento.favorecido}</TableCell>
                      <TableCell>R$ {documento.valor.toFixed(2)}</TableCell>
                    </TableRow>
                    <Modal
                      open={showEditConciliaco === index}
                      onClose={() => {
                        setEditConciliacao(-1);
                      }}
                      center
                      classNames={{
                        modal: "customModal",
                      }}
                    >
                      <ModalConciliacaoBancaria
                        closeModal={() => setEditConciliacao(-1)}
                        setList={setDocumentos}
                        list={documentos}
                        index={index}
                        refRelatorio={documento}
                      />
                    </Modal>
                  </>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={4}>TOTAL</TableCell>
                  <TableCell>
                    R$
                    {documentos
                      .reduce((acc, current) => acc + current.valor, 0)
                      .toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <div className={styles.addDiv}>
            <button
              className={styles.addBtn}
              onClick={(e) => {
                e.preventDefault();
                setAddConciliacao(true);
              }}
            >
              + Adicionar Documento
            </button>
          </div>
          <Modal
            open={showAddConciliacao}
            onClose={() => setAddConciliacao(false)}
            center
            classNames={{
              modal: "customModal",
            }}
          >
            <ModalConciliacaoBancaria
              closeModal={() => setAddConciliacao(false)}
              setList={setDocumentos}
              list={documentos}
            />
          </Modal>
        </div>
      </div>
    </form>
  );
};
export default ConciliacaoBancaria;
